var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[{ [_vm.$style.hasBackground]: _vm.hasBorderRadius }, _vm.$style.closeBtn, _vm.$style[_vm.widgetSide]],style:(_vm.computedStyle),on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"icon-miniX"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }